import React, { useState } from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';
import GifLoader from 'react-gif-loader';

import config from '../utils/config';
import Seo from '../components/Seo';
import Layout from '../components/Layout';
import HomeSignup from '../components/HomeSignup';
import ProductsList from '../components/ProductsList';
import HeroSlider from '../components/HeroSlider';
import CategoryList from '../components/CategoryList';
import Ingredients from '../components/Ingredients';
import Recipes from '../components/Recipes';

export const query = graphql`
  query HomePageQuery {
    sanitySiteSettings {
      title
      description
      homeHeroBanner {
        title
        image {
          asset {
            fluid(maxWidth: 1600) {
              ...GatsbySanityImageFluid
            }
          }
        }
      }
      ingredient {
        title
        subtitle
        image {
          asset {
            fluid(maxWidth: 700) {
              ...GatsbySanityImageFluid
            }
          }
        }
      }
    }
    allSanityProduct(
      filter: { status: { eq: "active" }, isFeatured: { eq: true } }
      sort: { fields: [listingOrder], order: ASC }
      limit: 4
    ) {
      edges {
        node {
          id
          title
          slug {
            current
          }
          otherVariants {
            pricing {
              country
              discountPrice
              price
            }
            quantity
            featuredImage {
              asset {
                fluid(maxWidth: 350) {
                  ...GatsbySanityImageFluid
                }
              }
            }
          }
        }
      }
    }
    allSanityCategory(sort: { fields: title, order: ASC }, limit: 8) {
      edges {
        node {
          id
          slug {
            current
          }
          image {
            asset {
              fluid {
                src
              }
            }
          }
          title
          parents {
            id
            slug {
              current
            }
          }
        }
      }
    }
  }
`;

const LoadingContainer = styled.div`
  .css-z6yr06 {
    margin: 0 auto !important;
  }
  @media screen and (min-width: 769px) {
    .hero-body {
      padding: 0 !important;
    }
  }
`;

const HomePage = ({ data }) => {
  const home = data.sanitySiteSettings;
  const products = data.allSanityProduct.edges;
  const allCategories = data.allSanityCategory.edges;
  const [active, setActive] = useState(true);
  setTimeout(() => setActive(false), 1000);
  return (
    <>
      {active && (
        <LoadingContainer className="hero is-medium">
          <div className="hero-body">
            <div className="container">
              <GifLoader
                overlayBackground="#ffff"
                loading
                imageSrc="/images/loader/loader.gif"
              />
            </div>
          </div>
        </LoadingContainer>
      )}
      {!active && (
        <Layout>
          <Seo
            title={home.title}
            description={home.description}
            url={config.siteUrl}
          />
          <HeroSlider data={home} />
          <ProductsList products={products} />

          <CategoryList data={allCategories} />
          <Ingredients data={home} />
          <Recipes />
          <HomeSignup />
        </Layout>
      )}
    </>
  );
};

export default HomePage;
